import type * as EquipmentCTA from '../types/EquipmentCTA'
import { imageParser } from '../props/parsers/Image'

export default function equipmentCTAComponentParser(
  rawComponent: EquipmentCTA.Raw,
): EquipmentCTA.Parsed {
  const { cards, ...rest } = rawComponent.equipmentCta

  return {
    name: 'EquipmentCTA',
    props: {
      cards: cards.map(({ image, headlineText, purchaseLink }) => ({
        purchaseLink,
        headlineText,
        ...imageParser(image),
      })),
      ...rest,
    },
  }
}
